import React, { useEffect, useState } from 'react';

import classes from "../SitesOnSchedule/sitesOnScheduleSearchBar.module.css"
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters.png'
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { ListBox } from 'primereact/listbox';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import DataManager from '../../hooks/DataManager';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';

const CCTVIntegrationsSearchBar = (props) => {
  const { 
        placeholder, 
        onChange, 
        value, 
        handleFocus, 
        handleBlur, 
        showFilterButton, 
        groups, 
        online, 
        setOnline, 
        offline, 
        setOffline, 
        deviceTag, 
        setDeviceTag, 
        integrationType, 
        setIntegrationType, 
        connectionIssues, 
        setConnectionIssues,
        groupName, 
        setGroupName,
        submit, 
        setSubmit
    } = props;
  
  const [showFilters, setShowFilters] = useState(false);

  const [localOnline, setLocalOnline] = useState(online);
  const [localOffline, setLocalOffline] = useState(offline);
  const [localDeviceTag, setLocalDeviceTag] = useState(deviceTag);
  const [localGroupName, setLocalGroupName] = useState(groupName);
  const [localIntegrationType, setLocalIntegrationType] = useState(null)
  const [localExcludes, setLocalExcludes] = useState("")
  const [localConnectionIssues, setLocalConnectionIssues] = useState(connectionIssues)

  const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
          event.preventDefault();
      }
  };

  const handleClear = () => {
      onChange({ target: { value: '' } }); 
  };

  const handleShowFilters = () => {
    setShowFilters(prev => !prev);
  };

  const HandleResetFilters = () => {
    setOnline(0)
    setOffline(0)
    setDeviceTag(null)
    setGroupName(null)
    setIntegrationType(null)
    setConnectionIssues(0)

    setLocalOnline(0)
    setLocalOffline(0)
    setLocalDeviceTag(null)
    setLocalGroupName(null)
    setLocalIntegrationType(null)
    setLocalConnectionIssues(0)

    setSubmit(submit+1)
    setShowFilters(false)
  }

  const HandleApplyFilters = () => {
    setOnline(localOnline)
    setOffline(localOffline)
    setDeviceTag(localDeviceTag)
    setGroupName(localGroupName)
    setIntegrationType(localIntegrationType)
    setConnectionIssues(localConnectionIssues)

    setShowFilters(false)
    setSubmit(submit+1)
  }


  const handleInputChange = (e) => {
    setLocalDeviceTag(e.target.value); // For debugging
  };

  const handleStatusChange = (status) => {
    if (status == "ONLINE"){
        setLocalOnline(localOnline == 1 ? 0 : 1)
    }

    if (status == "OFFLINE") {
        setLocalOffline(localOffline == 1 ? 0 : 1)
    }

    if (status == "ALL"){
        setLocalOnline(0)
        setLocalOffline(0)
    }
  }

  const handleIntegrationTypeChange = (type) => {
    setLocalIntegrationType(type)
  }

  return (
      <div className={classes.searchContainer}>
          <input
              className={classes.searchBar}
              placeholder={placeholder}
              value={value}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              spellCheck={false}
          />

          <div className={classes.buttonGroup}>
              {value && (
                  <button className={classes.clearButton} onClick={handleClear} type="button">
                      ×
                  </button>
              )}
              <button className={classes.filterButton} onClick={handleShowFilters} type="button">
                  <img style={{ height: '30px', width: '30px' }} src={filters}/>
              </button>
          </div>

          {showFilters && (
                <div className={classes.filterDropdown}>
                  
                    <div className={classes.filterRow}>
                    <div className="flex flex-wrap justify-content-center gap-3">
                    <div className="flex align-items-center">
                            <Checkbox  name="Online" value="localOnline" onChange={() => handleStatusChange("ALL")} checked={((localOnline == 0 && localOffline == 0) || (localOffline == 1 && localOnline == 1))} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">All</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="Online" value="localOnline" onChange={() => handleStatusChange("ONLINE")} checked={localOnline == 1} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">Site online</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="offline" value="localOffline" onChange={() => handleStatusChange("OFFLINE")} checked={localOffline == 1} />
                            <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">Site offline</label>
                        </div>
                      </div>
                    </div>
                    <Divider type="solid"/>
                    <div className="flex align-items-center" style={{ marginTop: "10px" }}>
                        <Checkbox name="lvEnabled" value="setConnectionIssues" onChange={() => setLocalConnectionIssues(localConnectionIssues == 1 ? 0 : 1)} checked={localConnectionIssues == 1} />
                        <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Only show CCTV systems with connection issues</label>
                    </div>
                    <Divider type="solid"/>
                    <div className={classes.filterRow2}>
                        <label style={{marginBottom:"5px"}}className={classes.filterLabel}>Group:</label>
                        <Dropdown
                            value={localGroupName}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalGroupName(e.value)}
                            options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                            placeholder="Choose group"
                        />
                    </div>

                    <Divider type="solid"/>                    
                    <div className={classes.filterRow}>
                    <div className="flex flex-wrap justify-content-center gap-3">
                    <div className="flex align-items-center">
                            <Checkbox  name="AJAX" value="localOnline" onChange={() => handleIntegrationTypeChange("AJAX")} checked={localIntegrationType == "AJAX"} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">AJAX</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="Dahua" value="localOnline" onChange={() => handleIntegrationTypeChange("DAHUA")} checked={localIntegrationType == "DAHUA"} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">Dahua</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="Hikvision" value="localOffline" onChange={() => handleIntegrationTypeChange("HIKVISION")} checked={localIntegrationType == "HIKVISION"} />
                            <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">Hikvision</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="AIBox" value="localOffline" onChange={() => handleIntegrationTypeChange("AIBOX")} checked={localIntegrationType == "AIBOX"} />
                            <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">AIBox</label>
                        </div>
                      </div>
                    </div>
                    <Divider type="solid"/>
                    <div className={classes.filterType2} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <label htmlFor="word" className="font-bold block mb-2">
                        Portal site name includes the word:
                      </label>                    
                      <InputText id="word" keyfilter="alphanum" value={deviceTag} onChange={handleInputChange}/>

                    </div>
                    <Divider type="solid"/>
                    <div className={classes.buttonRow}>
                      <Button  icon="pi pi-refresh"  type="button" style={{marginRight:"15px"}} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger'/>
                      <Button  icon="pi pi-check" type="button" label="Apply" onClick={HandleApplyFilters}/>
                    </div>
                </div>
            )}
      </div>
  );
};

export default CCTVIntegrationsSearchBar;